import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import { addLogBreadcrumb } from 'utils/logging.ts'

// A stale build's chunk hashes no longer exist on the server once a new deploy replaces them. Reload to fetch the
// current build instead of leaving the user stuck on a page that can never finish loading its module.
window.addEventListener('vite:preloadError', (event) => {
  addLogBreadcrumb('vite:preloadError', {
    message: event.payload?.message,
    pathname: window.location.pathname
  })

  window.location.reload()
})

const container = document.getElementById('root')
createRoot(container!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
